import { useCurrentUser } from '../../contexts/UserContext';
import QuickTiles from './sections/QuickTiles';
import UpcomingClasses from './sections/UpcomingClasses';
import ContinueLearning from './sections/ContinueLearning';
import Momentum from './sections/Momentum';

export default function StudentDashboard() {
  const currentUser = useCurrentUser();
  const userId = currentUser?.id || currentUser?._id;

  return (
    <div className="dashboard-content">
      <div className="welcome-inline">
        <h2>Welcome, {currentUser?.name?.split(' ')[0] || 'back'}!</h2>
      </div>

      <div className="main-feed">
        <QuickTiles />

        <div className="dual-panels">
          <UpcomingClasses />
        </div>

        <div className="focus-panels">
          <ContinueLearning />
          <Momentum userId={userId} />
        </div>
      </div>
    </div>
  );
}
